<template>
  <form @submit.prevent="submit">
    <v-row>
      <v-col cols="6">
        <DateSelector
          label="Od"
          :date="form.startDate"
          @change="updateStartDate"
        />
      </v-col>
      <v-col cols="6">
        <DateSelector
          label="Do"
          :date="form.endDate"
          @change="updateEndDate"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-show="!inventory"
        cols="12">
        <v-text-field
          v-model="form.label"
          label="Oznaka"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-show="!inventory"
        cols="4">
        <v-text-field
          v-model="form.id"
          label="Št. odpisa"
        ></v-text-field>
      </v-col>
      <v-col
        v-show="!inventory"
        cols="4">
        <v-checkbox
          hide-details
          color="#0F998E"
          v-model="form.includeArticles"
          label="Vsebuje artikle"
        ></v-checkbox>
      </v-col>
      <v-col cols="4">
        <v-btn type="submit" class="float-right">Išči</v-btn>
      </v-col>
    </v-row>
  </form>
</template>

<script>
import moment from 'moment'
import DateSelector from './DateSelector'

export default {
  props: ['inventory'],
  components: {
    DateSelector
  },
  data () {
    return {
      form: {
        startDate: '',
        endDate: '',
        label: null,
        id: null,
        includeArticles: 1
      }
    }
  },
  methods: {
    submit () {
      this.$emit('submit', this.form)
    },
    clearForm () {
      this.form = {
        startDate: null,
        endDate: null,
        id: null,
        label: null,
        includeArticles: 1
      }
    },
    updateStartDate ({ date }) {
      this.form.startDate = date
    },
    updateEndDate ({ date }) {
      this.form.endDate = date
    }
  },
  created () {
    this.clearForm()
    const storeFilters = this.$store.state.writeoffForms.filters
    if (storeFilters) {
      this.form.startDate = storeFilters.dateFrom
      this.form.endDate = storeFilters.dateTo
      this.form.label = storeFilters.label
      this.form.id = storeFilters.id
      this.form.includeArticles = storeFilters.includeArticles
    }
    if (!this.form.startDate) this.form.startDate = moment().subtract(30, 'days').format('YYYY-MM-DD')
    if (!this.form.endDate) this.form.endDate = moment().format('YYYY-MM-DD')
    // console.log(this.form)
    this.submit()
  }
}
</script>
